export const RTL_LANGUAGE_CODES = new Set(['ar', 'he'])

export const getLanguageDirection = languageCode => {
  if (!languageCode) return 'auto'
  return RTL_LANGUAGE_CODES.has(languageCode) ? 'rtl' : 'ltr'
}

export const getDirectionClassName = direction => {
  if (direction === 'rtl') return 'rtl-content'
  if (direction === 'ltr') return 'ltr-content'
  return ''
}
